import { useId } from 'react';

interface ToggleProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label?: string;
  id?: string;
}

export function Toggle({ checked, onChange, label, id }: ToggleProps) {
  const generatedId = useId();
  const toggleId = id ?? generatedId;
  return (
    <label className="wb-switch" htmlFor={toggleId}>
      <input
        id={toggleId}
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        aria-label={label}
      />
      <span className="wb-switch-track" />
      <span className="wb-switch-thumb" />
    </label>
  );
}
